import { State as AppState } from '..';
import { State } from './types';

export const selectTheme = (state: AppState): State => state.theme;
